interface MetricCardProps {
  title: string
  value: string | number
  icon: string
  trend?: 'positive' | 'negative' | null
  subtitle?: string
  premium?: boolean
  change?: string
  changePercent?: number
}

const MetricCard = ({ 
  title, 
  value, 
  icon, 
  trend, 
  subtitle, 
  premium = false,
  change,
  changePercent 
}: MetricCardProps) => {
  return (
    <div className={`${premium ? 'metric-card-premium' : 'metric-card'} slide-up h-full`}>
      <div className="flex flex-col h-full">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1 min-w-0">
            <p className={`${premium ? 'metric-label-premium' : 'metric-label'} truncate`}>
              {title}
            </p>
            <div className="mt-2">
              <p className={`${premium ? 'metric-value-premium' : 'metric-value'} break-words`}>
                {value}
              </p>
              {changePercent && (
                <span className={`text-sm font-semibold ${
                  premium 
                    ? changePercent >= 0 ? 'text-green-200' : 'text-red-200'
                    : changePercent >= 0 ? 'text-dashboard-success' : 'text-dashboard-error'
                }`}>
                  {changePercent >= 0 ? '+' : ''}{changePercent}%
                </span>
              )}
            </div>
            {subtitle && (
              <p className={`text-xs mt-1 ${premium ? 'text-globo-100' : 'text-dashboard-muted'} line-clamp-2`}>
                {subtitle}
              </p>
            )}
          </div>
          <div className={`text-2xl ml-2 flex-shrink-0 ${premium ? 'opacity-80' : ''}`}>
            {icon}
          </div>
        </div>
        
        {(trend || change) && (
          <div className="flex items-center justify-between pt-3 mt-auto border-t border-opacity-20 border-gray-200">
            {trend && (
              <div className={`metric-change ${trend}`}>
                <span className="mr-1">
                  {trend === 'positive' ? '📈' : '📉'}
                </span>
                <span className="text-xs">
                  {trend === 'positive' ? 'Tendencia positiva' : 'Tendencia negativa'}
                </span>
              </div>
            )}
            {change && (
              <div className={`text-xs font-medium ${premium ? 'text-globo-100' : 'text-dashboard-muted'}`}>
                {change}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default MetricCard
